// extracted by mini-css-extract-plugin
export default {"control":"Control_control__eUDPW","button":"Control_button__boxyO","download":"Control_download__vkhki","remove":"Control_remove__827pu"};